export var HealthcheckType;
(function (HealthcheckType) {
    HealthcheckType["Up"] = "up";
    HealthcheckType["MainLoop"] = "mainLoop";
    // device data is related to process action
    HealthcheckType["DeviceDataReceived"] = "deviceDataReceived";
    // Aggregated renderer liveness. Pinged by the platform layer only when every
    // expected renderer has sent a recent keep-alive; goes stale if any renderer
    // dies or hangs silently, so the OS-level watchdog can force a reboot.
    HealthcheckType["Renderer"] = "renderer";
})(HealthcheckType || (HealthcheckType = {}));
//# sourceMappingURL=HealthcheckManagerInterface.js.map